import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'transferStreams';
export const useTransferStreamsTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Перенести',
    on_success: 'Источники перенесены',
    on_error: 'Не удалось перенести источники',
    transfer_streams_form: {
      title: 'Перенос источников',
      group: 'Целевая группа',
      on_cancel: 'Отмена',
      on_submit: 'Перенести',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Transfer',
    on_success: 'Sources transferred',
    on_error: 'Failed to transfer sources',
    transfer_streams_form: {
      title: 'Transfer sources',
      group: 'Target group',
      on_cancel: 'Cancel',
      on_submit: 'Transfer',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Transferir',
    on_success: 'Fuentes transferidas',
    on_error: 'No se pudieron transferir las fuentes',
    transfer_streams_form: {
      title: 'Transferir fuentes',
      group: 'Grupo de destino',
      on_cancel: 'Cancelar',
      on_submit: 'Transferir',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Transferir',
    on_success: 'Fontes transferidas',
    on_error: 'Falha ao transferir fontes',
    transfer_streams_form: {
      title: 'Transferir fontes',
      group: 'Grupo de destino',
      on_cancel: 'Cancelar',
      on_submit: 'Transferir',
    },
  },
}) : {}) as Record<string, unknown>;
